import React, { lazy, ReactNode, Suspense } from 'react'

import { Grid, Row } from '@plurall/elo-beta'

import { getToken, isInApp } from 'utils'

import { getSubMenuItem } from '../../../utils/functions'
import Loading from '../Loading/Loading'

const WidgetLayout = lazy(() => import('exporterLayout/Layout'))

const WrapperLayout = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense fallback={<Loading />}>
      <WidgetLayout
        applicationId={process.env.REACT_APP_ID_APPLICATION}
        graphqlURL={process.env.REACT_APP_SOMOS_GRAPHQL_URL}
        userToken={getToken()}
        hideNavBar={isInApp()}
        menuSubItem={getSubMenuItem()}
        service='account'
        projectName='minha conta'
        plurallLogo
        menuURL={`${process.env.REACT_APP_PLURALL_MENU_API_URL}/plurall`}
        msApiURL={process.env.REACT_APP_MS_API_URL}
        apiKey={process.env.REACT_APP_FIREBASE_API_KEY}
        authDomain={process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}
        projectId={process.env.REACT_APP_FIREBASE_PROJECT_ID}
        storageBucket={process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}
        messagingSenderId={process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID}
        appId={process.env.REACT_APP_FIREBASE_APP_ID}
        measurementId={process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}
      >
        <Row>
          <Grid desktop={12} tablet={12}>
            {children}
          </Grid>
        </Row>
      </WidgetLayout>
    </Suspense>
  )
}

export default WrapperLayout
